
import { defineComponent, PropType, inject, computed, ref,onMounted, onUnmounted } from "vue";
import { CartSummary, CartRow } from "@/models/Cart";

export default defineComponent({
  props: {
    summary: {
      type: Object as PropType<CartSummary>,
      required: true
    },
    serviceItems: {
      type: Object as PropType<CartRow[]>,
      required: true
    },
    isSuperUser: {
      type: Boolean,
      required: false
    }
  },
  setup(props) { 
    const orderSummaryRef = ref<HTMLElement | null>(null);

    const handleScroll = () => {
      const orderSummary = orderSummaryRef.value;
      if (!orderSummary) return;

      const elementPosition = orderSummary.getBoundingClientRect().top;

      if (elementPosition <= 100) {
        orderSummary.classList.add('sticky');
      } else {
        orderSummary.classList.remove('sticky');
      }
    };

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    return {
      orderSummaryRef
    }
  },
  data() {
    return{
      showPricesAsB2b:false, hidePrices:false
    }
  },
  mounted() {
    this.showPricesAsB2b = inject<boolean>("show-prices-as-b2b", false);
    this.hidePrices = inject<boolean>("hide-prices", false);
  },
});
